var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.permission || _vm.myPermissions.includes(_vm.permission))?_c('v-btn',{style:(_vm.dark_t?'color:black':''),attrs:{"color":"secondary"},on:{"click":_vm.export_excel}},[_c('v-icon'),_c('span',[_vm._t("default",function(){return [_vm._v("Exportar Excel")]})],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }